module.exports = __webpack_public_path__ + "static/media/TrashJoes-monitor.583bab51.png";